import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatPhone'
})
export class FormatPhonePipe implements PipeTransform {

  transform(tel: string | null | undefined): string {
    if (!tel) return '';
    
    // Remove todos os caracteres não numéricos
    const value = tel.toString().replace(/\D/g, '');
    
    if (!value) return tel || '';
    
    // Formatação baseada no comprimento do número
    if (value.length === 13) {
      // Número internacional completo com código do Brasil: +55 (XX) XXXXX-XXXX
      return `+${value.substring(0, 2)} (${value.substring(2, 4)}) ${value.substring(4, 9)}-${value.substring(9)}`;
    } else if (value.length === 12) {
      // Número internacional com código do Brasil e telefone fixo: +55 (XX) XXXX-XXXX
      return `+${value.substring(0, 2)} (${value.substring(2, 4)}) ${value.substring(4, 8)}-${value.substring(8)}`;
    } else if (value.length === 11) {
      // Celular com DDD: (XX) XXXXX-XXXX
      return `(${value.substring(0, 2)}) ${value.substring(2, 7)}-${value.substring(7)}`;
    } else if (value.length === 10) {
      // Telefone fixo com DDD: (XX) XXXX-XXXX
      return `(${value.substring(0, 2)}) ${value.substring(2, 6)}-${value.substring(6)}`;
    } else if (value.length === 9) {
      // Celular sem DDD: XXXXX-XXXX
      return `${value.substring(0, 5)}-${value.substring(5)}`;
    } else if (value.length === 8) {
      // Telefone fixo sem DDD: XXXX-XXXX
      return `${value.substring(0, 4)}-${value.substring(4)}`;
    } 
    
    // Para casos onde queremos forçar o formato internacional
    // mesmo que o número não tenha todos os dígitos
    else if (value.length > 13) {
      // Número muito longo - tenta formatar como internacional
      return `+${value.substring(0, 2)} ${value.substring(2)}`;
    } else if (value.length > 11 && value.length < 13) {
      // Possível número internacional incompleto - aplica melhor formatação possível
      return `+${value.substring(0, 2)} ${value.substring(2)}`;
    }
    
    // Para outros formatos, retorne apenas o número limpo
    return value;
  }

}
